import PropTypes from 'prop-types';
import React, {Component} from 'react';
import classNames from 'classnames';
import './StarRating.less';

/**
 * StarRating
 *
 * TODO: div needs aria-label="1.4 out of 5" messaging -- need MessageFormat solution
 * TODO: determine any need for displaying roundRating value next to stars
 */

class StarRating extends Component {
    static propTypes = {
        /** Raw Rating Number.  StarRating will round to the correct half star. */
        rating: PropTypes.number.isRequired,
        /** The StarRating size variation, one of: 'lg'|'sm' */
        size: PropTypes.oneOf(['lg', 'sm'])
    }

    constructor(props) {
        super(props);

        let rating = this.roundRating(props.rating);

        this.state = {
            rating,
            ratingClass: this.getRatingClass(rating)
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.rating !== this.props.rating) {
            let roundRating = this.roundRating(nextProps.rating);

            this.setState({
                roundRating,
                ratingClass: this.getRatingClass(roundRating)
            });
        }
    }

    shouldComponentUpdate(nextProps) {
        return (nextProps.rating !== this.props.rating);
    }

    roundRating(rawRating) {
        return (Math.round(rawRating * 2) / 2).toFixed(1);
    }

    getRatingClass(roundedRating) {
        let affix = this.roundRating(roundedRating).replace('.0', '').replace('.5', '-5');

        return `StarRating__stars StarRating__stars--${affix}`;
    }

    renderStars = (className) => {
        let height = 16;
        let width = 86;

        if (this.props.size === 'sm') {
            height = 12;
            width = 66;
        }

        if (this.props.size === 'lg') {
            height = 24;
            width = 130;
        }

        return (
            <svg className={className} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 86 16">
                <path stroke="none" fill="currentColor" d="M14.9 6.7l-3.4 3.4.9 4.5-.1.3h-.4L8 12.4l-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.5-3.4-.1-.3c.1-.1.1-.2.3-.2h4.5l2-5.1L8 1l.3.2 2 5.1h4.5l.3.2-.2.2zm70 0l-3.4 3.4.9 4.5-.1.3h-.4L78 12.4l-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4c-.2 0-.2-.1-.2-.3.1-.1.1-.2.3-.2h4.5l2-5.1.2-.1.3.2 2 5.1h4.5l.3.2-.2.2zm-17.5 0L64 10.1l.9 4.5-.1.3h-.4l-3.9-2.5-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4-.1-.3c.1-.1.1-.2.3-.2h4.5l2-5.1.1-.1.3.2 2 5.1h4.5l.3.2-.2.2zm-17.5 0l-3.4 3.4.9 4.5-.1.3h-.4L43 12.4l-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4c-.2 0-.2-.1-.2-.3.1-.1.1-.2.3-.2h4.5l2-5.1.2-.1.3.2 2 5.1h4.5l.3.2-.2.2zm-17.5 0L29 10.1l.9 4.5-.1.3h-.4l-3.9-2.5-3.9 2.5h-.3c-.1-.1-.2-.2-.1-.3l.9-4.5-3.4-3.4-.1-.3c.1-.1.1-.2.3-.2h4.5l2-5.1.1-.1.3.2 2 5.1h4.5l.3.2-.2.2z"/>
            </svg>
        );
    }

    render() {
        const {rating, size, className, ...rest} = this.props;  // eslint-disable-line no-unused-vars
        const {roundRating, ratingClass} = this.state;
        const ratingClasses = classNames('StarRating', {[`StarRating--${size}`]: size}, className);
        const bottomStarClasses = classNames('StarRating__stars', {[`StarRating__stars--${size}`]: size});
        const topStarClasses = classNames('StarRating__stars', {[`StarRating__stars--${size}`]: size}, ratingClass);

        return (
            <div className={ratingClasses}>
                {!(roundRating === 5) &&
                    <div className={bottomStarClasses}>
                        {this.renderStars(classNames('StarRating__svg'))}
                    </div>
                }
                {!(roundRating === 0) &&
                <div className={topStarClasses}>
                    {this.renderStars(classNames('StarRating__svg', 'StarRating__svg--top'))}
                </div>
                }
            </div>
        );
    }
}

export default StarRating;
